/**
 * Split inbox body "Event · entity" for compact previews.
 * Title is the actor/sender; body carries the event line.
 */
export function splitNotificationBody(body: string): {
  action: string
  detail: string | null
} {
  const raw = body?.trim() ?? ''
  if (!raw) return { action: '', detail: null }

  const sep = ' · '
  const index = raw.indexOf(sep)
  if (index === -1) return { action: raw, detail: null }

  const action = raw.slice(0, index).trim()
  const detail = raw.slice(index + sep.length).trim()
  return {
    action: action || raw,
    detail: detail || null,
  }
}
